export const formatValue = (value) => {
    if (value === null || value === undefined) return "-";
  
    if (typeof value === "object") {
      if (value instanceof Date) {
        return value.toLocaleDateString();
      }
      if (Array.isArray(value)) {
        return value.join(", ");
      }
  
      return Object.entries(value)
        .map(([key, val]) => `${key}: ${val}`)
        .join(", ");
    }
  
    if (typeof value === "number") {
      return Number.isInteger(value) ? value : value.toFixed(2);
    }
  
    return value.toString();
  };
  
  export const getVerificationStatus = (verifications) => {
    const allPassed = Object.values(verifications).every(
      (v) => v.Passed === true || v.Result === true
    );
    const anyFailed = Object.values(verifications).some(
      (v) => v.Passed === false || v.Result === false
    );
    return allPassed ? "success" : anyFailed ? "error" : "warning";
  };
  
  export const getSuccessdVerificationCount = (verifications) => {
    console.log("verifications",verifications);
    
    return Object.values(verifications).filter(      
      (v) => v.Passed === true || v.Result === true
    ).length;
  };
  
  export const getVerificationCount = (verifications) => {
    return Object.values(verifications).length;
  };